<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
            AUTH REDIRECT
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
    }
  },

  methods: {
  },

  created() {
    this.$vs.loading();
    //const result = this.$msal.signIn();
  },

  destroyed() {
    this.$vs.loading.close();
  }
}
</script>

<style lang="scss">
</style>
